// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  background: #002940;
  padding-bottom: 10px;
  overflow: hidden;
}
.container > * {
  z-index: 10;
}
.container h1, .container p {
  color: white;
  text-align: center;
  max-width: 280px;
}
.container .background-picture {
  position: relative;
  max-height: 150px;
  z-index: 9999;
}
.container .before, .container .after {
  z-index: 5;
}
.container .before {
  position: absolute;
  left: 0;
  top: 80px;
}
.container .after {
  position: absolute;
  right: 0;
  top: 220px;
}`, "",{"version":3,"sources":["webpack://./src/@fuse/components/footer/footer.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AACJ;AAAI;EACI,WAAA;AAER;AACI;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;AACR;AAEI;EACI,kBAAA;EACA,iBAAA;EACA,aAAA;AAAR;AAEI;EACI,UAAA;AAAR;AAEI;EACI,kBAAA;EACA,OAAA;EACA,SAAA;AAAR;AAGI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;AADR","sourcesContent":[".container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: relative;\r\n    align-items: center;\r\n    background: #002940;\r\n    padding-bottom: 10px;\r\n    overflow: hidden;\r\n    > * {\r\n        z-index: 10;\r\n    }\r\n    \r\n    h1, p {\r\n        color: white;\r\n        text-align: center;\r\n        max-width: 280px;\r\n    }\r\n    \r\n    .background-picture {\r\n        position: relative;\r\n        max-height: 150px;\r\n        z-index: 9999;\r\n    }\r\n    .before, .after {\r\n        z-index: 5;\r\n    }\r\n    .before {\r\n        position: absolute;\r\n        left: 0;\r\n        top: 80px;\r\n    }\r\n    \r\n    .after {\r\n        position: absolute;\r\n        right: 0;\r\n        top: 220px;\r\n    }\r\n    \r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
